@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="padding-bottom: 20px; padding-left: 1em; padding-right: 1em; padding-top: 1em">
    <h3 style="margin: 0">Urit</h3>
    <div>
      Lemonatorissa: <a [href]="lemonatorProjektitEncodedUriObservable | async" target="_BLANK">{{ lemonatorProjektitUriObservable | async }}</a>
    </div>
    <div>
      Lemonaidissa: <a [href]="lemonaidProjektitEncodedUriObservable | async" target="_BLANK">{{ lemonaidProjektitUriObservable | async }}</a>
    </div>
  </div>
}

<div class="projekti-container">
  @if (projektitArrayObservable | async; as kaikkiProjektitGroupit) {
    <div>
      @if (kaikkiProjektitGroupit?.length) {
        <table>
          <thead class="checkbox-title-row">
            <th></th>
            <th></th>
            <th class="checkbox-title">Lemonaidissa</th>
            <th class="checkbox-title">Kirjanpidossa</th>
            <th class="checkbox-title">Raporteilla</th>
          </thead>
          @for (projekti of kaikkiProjektitGroupit; track projekti) {
            <tr>
              <td>
                <mat-form-field class="projektin-nimi">
                  <mat-label>Nimi</mat-label>
                  <input #nimi type="text" [formField]="projekti.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                  <mat-error>
                    @if (onkoVirhe(projekti.nimi, 'required')) {
                      Lisää nimi
                    }
                  </mat-error>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field class="projektin-vari">
                  <mat-label>Väri</mat-label>
                  <mat-select [className]="colorNameAndClassMap[projekti.vari().value()]" style="font-weight: bold" [formField]="projekti.vari">
                    <mat-option value="pun"><span class="red-text">Punainen</span></mat-option>
                    <mat-option value="sin"><span class="blue-text">Sininen</span></mat-option>
                    <mat-option value="vsi"><span class="light-blue-text">Vaalean sininen</span></mat-option>
                    <mat-option value="kel"><span class="yellow-text">Keltainen</span></mat-option>
                    <mat-option value="vih"><span class="green-text">Vihreä</span></mat-option>
                    <mat-option value="vio"><span class="purple-text">Violetti</span></mat-option>
                    <mat-option value="har"><span class="light-gray-text">Harmaa</span></mat-option>
                  </mat-select>
                  <mat-error>
                    @if (onkoVirhe(projekti.vari, 'required')) {
                      Valitse väri
                    }
                  </mat-error>
                </mat-form-field>
              </td>
              <td>
                <mat-checkbox class="checkbox" [formField]="projekti.viewableInLemonaid"></mat-checkbox>
              </td>
              <td>
                <mat-checkbox class="checkbox" [formField]="projekti.usableInLemonator"></mat-checkbox>
              </td>
              <td>
                <mat-checkbox class="checkbox" [formField]="projekti.viewableInLemonator"></mat-checkbox>
              </td>
            </tr>
          }
        </table>
      } @else {
        <div style="padding: 90px 40px; text-align: center; font-size: 20px; color: darkgray">Asiakkaalla ei ole vielä yhtään projektia.</div>
      }
    </div>
  } @else {
    <div style="padding: 90px 40px; text-align: center; font-size: 20px; color: darkgray">
      Ladataan asiakkaan projekteja.
      <mat-progress-bar style="margin-top: 15px" mode="indeterminate"></mat-progress-bar>
    </div>
  }
</div>
